import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  dashboard: {
    id: 'header.menu.dashboard.label',
    defaultMessage: 'Dashboard',
    description: 'The text for the user menu Dashboard navigation.jsx link.',
  },
  profile: {
    id: 'header.menu.profile.label',
    defaultMessage: 'Profile',
    description: 'The text for the user menu Profile navigation.jsx link.',
  },
  account: {
    id: 'header.menu.account.label',
    defaultMessage: 'Account',
    description: 'The text for the user menu Account navigation.jsx link.',
  },
  orderHistory: {
    id: 'header.menu.orderHistory.label',
    defaultMessage: 'Order History',
    description: 'The text for the user menu Order History navigation.jsx link.',
  },
  skipNavLink: {
    id: 'header.navigation.jsx.skipNavLink',
    defaultMessage: 'Skip to main content.',
    description: 'A link used by screen readers to allow users to skip to the main content of the page.',
  },
  signOut: {
    id: 'header.menu.signOut.label',
    defaultMessage: 'Sign Out',
    description: 'The label for the user menu Sign Out action.',
  },
  courseCatalog: {
    id: 'header.menu.courseCatalog',
    defaultMessage: 'Course catalog',
  },
  courses: {
    id: 'header.menu.courses',
    defaultMessage: 'Courses',
  },
  programs: {
    id: 'header.menu.programs',
    defaultMessage: 'Programs',
  },
  partnership: {
    id: 'header.menu.partnership',
    defaultMessage: 'Partnership',
  },
  about: {
    id: 'header.menu.about',
    defaultMessage: 'About',
  },
  help: {
    id: 'header.menu.help',
    defaultMessage: 'Help',
  },
  myCourses: {
    id: 'header.profile.myCourses',
    defaultMessage: 'My courses',
  },
  myPrograms: {
    id: 'header.profile.myPrograms',
    defaultMessage: 'My programs',
  },
  myProfile: {
    id: 'header.profile.myProfile',
    defaultMessage: 'My profile',
  },
});

export default messages;
